import { useEffect } from "react";
import { LAST_LOGIN, LAST_LOGOUT } from "../constants";
import { getUID } from "../utils";

function useRecoverLastSessionDetails(isAuthenticated: boolean): {
    getSessionRecoveryData: () => { login: string; logout: string } | null;
    clearSessionRecoveryData: () => void;
} {
    useEffect(() => {
        const uid = getUID();

        if (isAuthenticated && uid) {
            if (!localStorage.getItem(`${LAST_LOGIN}_${uid}`)) {
                const now = new Date();
                const end = `${now.toDateString()} ${now.toTimeString()} ms:${now.getTime()}`;
                localStorage.setItem(`${LAST_LOGIN}_${uid}`, String(end));
            }
        }
    }, [isAuthenticated])

    const getSessionRecoveryData = () => {
        const uid = getUID();
        if (!uid) return null;

        const lastLogin = localStorage.getItem(`${LAST_LOGIN}_${uid}`);
        const lastLogout = localStorage.getItem(`${LAST_LOGOUT}_${uid}`);

        if (lastLogin && lastLogout) {
            return { login: lastLogin, logout: lastLogout };
        }
        return null;
    };

    // ADD: Clear session recovery data after it's been logged
    const clearSessionRecoveryData = () => {
        const uid = getUID();
        if (!uid) return;
        
        localStorage.removeItem(`${LAST_LOGOUT}_${uid}`);
        // Update login timestamp to current session
        const now = new Date();
        const end = `${now.toDateString()} ${now.toTimeString()} ms:${now.getTime()}`;
        localStorage.setItem(`${LAST_LOGIN}_${uid}`, String(end));
    };

    return { getSessionRecoveryData, clearSessionRecoveryData };
}

export default useRecoverLastSessionDetails;
